import "../css/topnavbar.css";

export default function TopNavBar({children}: {children: JSX.Element}) {
    return (
        <div className='top-navbar'>
            {children}
        </div>
    )
}